import { CreateFlightItineraryState } from './createFlightItinerary.types'

const initialState: CreateFlightItineraryState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
